module.exports = __webpack_public_path__ + "media/customizations/samlarc/back-b9b38ca897e77c4001d58bad784ca13c.jpg";